define('flight-components/mixins/withSearchSuggest',[
  'App',
  'flight/lib/compose',
  'flight-components/mixins/withData',
  'hogan',
  'components/typeahead.js/dist/typeahead.bundle.min'
],
function(App, compose, withData, Hogan) {

  var withSearchSuggest = function withSearchSuggest() {

    compose.mixin(this, [withData]);

    this.initTypeahead = function() {
      var self = this;

      var affiliate_template = Hogan.compile('<div id="affiliate-sugg"><a title="{{{businessName}}}" href="{{bppURL}}" data-dtm="click-search-suggest"><div class="suggested-image"><img src="{{logoURL}}" /></div> <div class="suggested-term">{{{businessName}}}</div></a></div>');

      var local_template = Hogan.compile('<div id="local-sugg"><a title="{{{businessName}}}" href="' + App.context + '{{bppURL}}" data-dtm="click-search-suggest"><div class="suggested-image"><img src="{{logoURL}}" /></div> <div class="suggested-term">{{{businessName}}}</div></a></div>');

      var snip_snap_template = Hogan.compile('<div id="snip-snap-sugg"><a title="{{{businessName}}}" href="{{bppURL}}" data-dtm="click-search-suggest"><div class="suggested-image"><img src="{{logoURL}}" /></div> <div class="suggested-term">{{{businessName}}}</div></a></div>');

      var topsearch_template = Hogan.compile('<div id="top-sugg"><a title="{{{businessName}}}" href="' + App.context + '/query?geo=' + App.results.geoLocation + '&f1=keyword&keywords={{businessName}}" data-dtm="click-search-suggest"><div class="suggested-image"><span class="icon-search-1" /></div> <div class="suggested-term">{{{businessName}}}</div></a></div>');

      var searchSuggest = function() {
        return function findMatches(query, cb) {
          var matches = [];
          // var api = App.server == 'https://www.valpak.com' ? 'api' : 'apidev';
          var api = App.server == 'https://www.valpak.com' ? 'api' : 'api';
          self.get('https://' + api + '.valpak.com/pub/auto/name/businessname?term=' + query + '&count=5&geo=' + App.results.geoLocation, function(response) {
            cb(response);
          });

          // TEMP until Sean enables single type selection of data
          $('.header__search-form .tt-dataset-suggestions').hide();
          $('.header__search--compact .tt-dataset-suggestions').hide();
          setTimeout(function() {
            if ($("#affiliate-sugg").length > 0) {
              $('.affiliate-sugg').parent().show();
            }
            if ($("#local-sugg").length > 0) {
              $('.local-sugg').parent().show();
            }
            if ($("#snip-snap-sugg").length > 0) {
              $('.snip-snap-sugg').parent().show();
            }
            if ($("#top-sugg").length > 0) {
              $('.top-sugg').parent().show();
            }
          }, 300);
        };
      };

      this.select('keywordInputSelector').typeahead({
        hint: true,
        highlight: true,
        minLength: 2
      },
      {
        name: 'suggestions',
        display: 'affiliate',
        source: searchSuggest(),
        templates: {
          header: '<div class="section-header affiliate-sugg">Online Coupon Codes</div>',
          suggestion: function(suggested) {
            if (suggested.businessType == 'AFFILIATE') {
              return unescape(affiliate_template.render(suggested));
            }
          }
        }
      },
      {
        name: 'suggestions',
        display: 'local',
        source: searchSuggest(),
        templates: {
          header: '<div class="section-header local-sugg">Businesses near ' + App.results.geoLocation + '<a class="change-geo js-geo-change" href="javascript:;" data-dtm="suggested-change-geo">Change Location</a></div>',
          suggestion: function(suggested) {
            if (suggested.businessType == 'LOCAL' && !suggested.bppURL.includes('snipsnap')) {
              return unescape(local_template.render(suggested));
            }
          }
        }
      },
      {
        name: 'suggestions',
        display: 'snip-snap',
        source: searchSuggest(),
        templates: {
          header: '<div class="section-header snip-snap-sugg">Retail Stores<a class="change-geo js-geo-change" href="javascript:;" data-dtm="suggested-change-geo">Change Location</a></div>',
          suggestion: function(suggested) {
            var url = suggested.bppURL;
            if (url.includes('snipsnap')) {
              return unescape(snip_snap_template.render(suggested));
            }
          }
        }
      },
      {
        name: 'suggestions',
        display: 'top-searches',
        source: searchSuggest(),
        templates: {
          header: '<div class="section-header top-sugg">Top Searches</div>',
          suggestion: function(suggested) {
            if (suggested.businessType == 'TOP_SEARCH') {
              return unescape(topsearch_template.render(suggested));
            }
          }
        }
      });

      self.on('typeahead:opened', function(ev, suggested) {
        self.select('keywordInputSelector').removeClass('error');
        self.select('errorMsgSelector').hide();
      })

      self.on('typeahead:selected', function(ev, suggested) {

      });

      self.on('typeahead:cursorchanged', function(ev, suggested) {

      });

      self.on('typeahead:autocompleted', function(ev, suggested) {

      });

    };

    this.after('initialize', function() {

      var self = this;
      if (self.attr.typeahead) {
        self.initTypeahead();
      }

    });

  };

  return withSearchSuggest;

});

